import { Form } from 'react-final-form';

import { Redirect } from '@change-corgi/core/react/router';

import { FormRender } from './components/FormRender/index_new';
import { useCreatePetitionUpdateForm } from './hooks/useCreatePetitionUpdateForm/index_new';
import type { PetitionUpdateFormValues } from './types';

export function CreatePetitionUpdateForm() {
	const { data, actions } = useCreatePetitionUpdateForm();

	return (
		<>
			{data.success && <Redirect to={`/p/${data.slug}/u/${data.success}?recently_published=true`} />}
			<Form<PetitionUpdateFormValues>
				data-qa="create-petition-update-form"
				onSubmit={actions.onSubmit}
				mutators={{ setTitle: actions.titleMutator }}
				render={({ hasValidationErrors, handleSubmit }) => (
					<FormRender
						handleSubmit={handleSubmit}
						hasValidationErrors={hasValidationErrors}
						initialValues={data.initialValues}
						isCurrentlyLoading={data.isCurrentlyLoading}
						onPreview={actions.onPreview}
						uploader={data.uploader}
						error={data.error}
					/>
				)}
			/>
		</>
	);
}
